<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <MensagemAlerta class="row-space" v-if="msgAlerta" :mensagem="msgAlerta" /> 

    <div class="form-edit-page row-space">
        <div class="row row-space">
            <div class="form-item-char10">
                <label class="label-caption">Cupom</label>
                <div class="field-label field-label-end">{{ Funcoes.formatInteger(objView.nrocupom) }}</div>
            </div>

            <div class="form-item-data">
                <label class="label-caption">Data Emissão</label>
                <div class="field-label field-label-center">{{ Funcoes.formatDateFromJson(objView.dhemissao) }}</div>
            </div>

            <div class="form-item">
                <label class="label-caption">Nome Participante</label>
                <div class="field-label">{{ objView.nmpessoa }}</div>
            </div>
            
            <div class="form-item-char40">
                <label class="label-caption">Programa</label>
                <div class="field-label">{{ objView.nmprograma }}</div>
            </div>
        </div>
        
        <div class="row-end">
            <button type="button" @click="closeForm">Retornar</button>
        </div>
    </div>

    <div v-if="lsDados.length>0" class="table-wrapper">
        <table>
            <thead>
                <tr>
                    <th class="col-width-char20">Nota Vinculada</th>
                    <th class="col-width-char10">Tipo</th>
                    <th>Fornecedor</th>
                    <th class="col-width-char20">Valor Nota</th>
                    <th class="col-width-char20">Utilizado</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(obj, index) in lsDados" :key="obj.id" :class="{'even-row': index % 2 === 0, 'odd-row': index % 2 !== 0}">
                    <td class="right">{{ Funcoes.formatInteger(obj.dfnumero) }}</td>
                    <td class="center">{{ `${obj.tpnota} / ${obj.dfmodelo ?? ''}` }}</td>
                    <td>{{ obj.nmfornecedor }}</td>
                    <td class="right">{{ Funcoes.formatDecimal(obj.vlautorizado) }}</td>
                    <td class="right">{{ Funcoes.formatDecimal(obj.vlutilizado) }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import { Api } from '@/funcoes/apiExport';
import { Funcoes } from '@/funcoes/utils';
import { globalStore } from '@/globals';
import MensagemAlerta from '@/components/MensagemAlerta.vue';

const emit = defineEmits(['close']);
const props = defineProps({idView: {type: Number, default: 0}});

const isLoading = ref(false);
const lsDados = ref([]);
const msgAlerta = ref(false);
const objView = ref({});

function closeForm() {emit('close');}

async function lerDados() {
    try{
        msgAlerta.value=null;
        isLoading.value = true;
        const req = await Api.genericPost('/listas/cupons', {idmunicipio: globalStore.idmunicipio, id: props.idView});
        Object.assign(objView.value, req[0]);

        const reqNotas = await Api.genericPost('/listas/cupons_notas', {
            idmunicipio: globalStore.idmunicipio,
            intparam1: props.idView});
        lsDados.value = reqNotas;
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`;
    }finally{isLoading.value = false;}
}

onMounted(lerDados);
</script>